import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import ProgramLogsService from "../../app/data/documents/programLogsService";
import { initialProgramLogsState } from "./ProgramLogsState";
import { ProgramLogsFilterModel } from "../../app/data/documents/programLogsModels";

const programLogsService = ProgramLogsService.getInstance();

export const programLogsSlice = createSlice({
  name: "programLogs",
  initialState: initialProgramLogsState,
  reducers: {
    requestStarted: (state, { payload }) => {
      state.requestStarted = true;
      state.requestSucceed = false;
      state.requestFailed = false;
      state.requestError = "";
      state.requestCreator = payload;
    },
    requestSucceed: (state) => {
      state.requestStarted = false;
      state.requestSucceed = true;
    },
    requestFailed: (state, { payload }) => {
      state.requestStarted = false;
      state.requestSucceed = false;
      state.requestFailed = true;
      state.requestError = payload;
    },
    resetErrors: (state) => {
      state.requestFailed = false;
      state.requestError = "";
    },
    setRecordsRequest: (state, { payload }) => {
      state.recordsRequest = {
        page: payload.page,
        last: payload.last
      }
    },
    setRecords: (state, { payload }) => {
      state.records = payload;
    },
    addRecords: (state, { payload }) => {
      state.records = [...state.records, ...payload];
    },
    setPgmHistoryCsvDownload: (state, {payload}) => {
        state.downloadCsv = payload;
    },
    setTableInfo: (state, { payload }) => {
      state.tableInfo = payload;
  }
  }
});

export const {
  requestStarted,
  requestSucceed,
  requestFailed,
  resetErrors,
  setRecordsRequest,
  setRecords,
  addRecords,
  setPgmHistoryCsvDownload,
  setTableInfo
} = programLogsSlice.actions;

export const programLogsSelector = (state: IState) => state.programLogs;

export const getProgramLogs = (
  filter: ProgramLogsFilterModel,
  page: number
): AppThunk => async (dispatch) => {
  dispatch(requestStarted(page ? "GET_RECORDS_PORTION" : "GET_RECORDS"));
  const response = await programLogsService.getProgramLogsRecords(filter, page);
  if (response.isCancel?.()) return;
  if (response.ok()) {
    dispatch(setRecordsRequest({
      page: response.data?.page,
      last: response.data?.totalPages
    }));
    dispatch(page ? addRecords(response.data.extractedResult) : setRecords(response.data.extractedResult));
    dispatch(requestSucceed());
  } else {
    dispatch(requestFailed(response.getError ? response.getError() : "Error"));
  }
};

export const getProgramLogsTableInfo = (): AppThunk => async (dispatch) => {
    const response = await programLogsService.getProgramLogsTableInfo();
    if (response.isCancel?.()) return;
    if (response.ok()) {
        dispatch(setTableInfo(response.data));
    } else {
        dispatch(requestFailed(response.getError ? response.getError() : "Error"));
    }
};
export const updatePgmHistoryCsvDownload = (downloadCsv: boolean): AppThunk => (dispatch) => {
    dispatch(setPgmHistoryCsvDownload(downloadCsv));
};
const programLogsReducer = programLogsSlice.reducer;
export default programLogsReducer;
